import { MenuItem } from '@mui/material';
import React from 'react';
import { SpeakerEntry } from '../../../../../interfaces/pagebuilder';
import VySelect from '../../../../common/VySelect';

interface SpeakerSelectInputProps {
  availableSpeakers?: SpeakerEntry[];
  onSubmit: (selectedSpeaker: SpeakerEntry) => void;
}

export const SpeakerSelectInput = (props: SpeakerSelectInputProps) => {
  const { onSubmit, availableSpeakers } = props;

  function submit(selectedEntryId: string) {
    if (!selectedEntryId) return;
    const match = availableSpeakers?.find((value) => value._id === selectedEntryId);
    if (match) onSubmit(match);
  }

  if (!availableSpeakers || availableSpeakers.length === 0) return <></>;

  return (
    <>
      <VySelect
        fullWidth
        onChange={(e: any) => {
          submit(e.target.value);
        }}
        MenuProps={{
          style: { zIndex: 1320 },
        }}>
        <MenuItem disabled={true} value=""></MenuItem>
        {availableSpeakers && availableSpeakers.map((speaker) => <MenuItem value={speaker._id}>{speaker.name}</MenuItem>)}
      </VySelect>
    </>
  );
};
